<template>
  <div class="se-card" :class="'se-card--' + this.width">
    <div class="se-card__inner" :style="[{backgroundImage: this.backgroundImg}, {backgroundColor: this.bgColor}]">
      <div class="se-card__img-overlay" v-if="hasBgImg"></div>
      <div class="se-card__content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SnapshotCard',
  props: {
    double: {
      type: Boolean
    },
    bgc: {
      type: String
    },
    bgimg: {
      type: String
    }
  },
  data () {
    return {

    }
  },
  computed: {
    width () {
      if (this.double === true) {
        return 'double'
      } else {
        return 'single'
      }
    },
    hasBgImg () {
      if (this.bgimg !== undefined) {
        return true
      } else {
        return false
      }
    },
    backgroundImg () {
      return this.hasBgImg ? 'url(' + this.bgimg + ')' : 'none'
    },
    hasBgc () {
      if (this.bgc !== undefined) {
        return true
      } else {
        return false
      }
    },
    bgColor () {
      return this.hasBgc ? this.bgc : '#ffffff'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../scss/vars';
  .se-card {
    width: 100%;
    height: auto;
    @media (min-width: 768px) {
      width: 50%;
      height: 279px;
    }
    @media (min-width: 960px) {
      width: 25%;
    }
    &--double {
      width: 100%;
      @media (min-width: 768px) {
        width: 50%;
      }
    }
    &.no-overlay {
      @media (min-width: 768px) {
        min-height: auto;
      }
      .se-card__img-overlay {
        display: none;
      }
    }
    &.minheight {
      min-height: 280px;
      @media (min-width: 768px) {
        min-height: auto;
      }
    }
    &__inner {
      display: flex;
      flex-flow: column;
      justify-content: flex-start;
      width: 100%;
      height: calc(100% - 10px);
      position: relative;
      padding-left: 25px;
      padding-right: 25px;
      padding-top: 40px;
      padding-bottom: 40px;
      background-color: $white;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: 50% 50%;
      border-width: 1px;
      border-style: solid;
      border-color: rgba(0,0,0,0.04);
      @media (min-width: 768px) {
        padding-top: 30px;
        padding-bottom: 20px;
        width: calc(100% - 10px);
      }
      &:before {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 0;
        box-shadow: 0px 18px 28px 0px rgba(0,0,0,0.04);
      }
      p {
        margin: 0;
        font-family: $font-primary;
        font-size: 13px;
        font-weight: 500;
        line-height: 21px;
        letter-spacing: 0.04em;
        @media (min-width: 768px) {
          font-size: 15px;
          line-height: 23px;
        }
      }
      ul {
        padding-left: 20px;
      }
    }
    &__content {
      z-index: 2;
    }
    &__img-overlay {
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,0.4);
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SnapshotCard.vue